import React, { useEffect, useState } from 'react';
import { DeleteIcon } from 'tdesign-icons-react';
import { Button, Drawer, Link, Loading, MessagePlugin, Popconfirm, Tabs } from 'tdesign-react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { useMemoizedFn } from 'ahooks';
import { fetctNamespaceDetailOverView } from '@/slices/namespaceSlice';
import { deleteNamespace } from '@/services/namespaceService';
import ModalHeader from '@/components/Header/Modal';
import PermWrapper from '@/components/PermWrapper';
import DisableWrapper from '@/components/DisableWrapper';
import { deal70101 } from '@/utils/common';
import ConfigPanel from './ConfigPanel';
import Summary from './Summary';
import BasicPanel from './BasicPanel';
import PermissionPanel from './PermissionPanel';
import GeoPanel from './GeoPanel';

const { TabPanel } = Tabs;

function Detail({ loading, namespace, clusterName, onDelete, fetctNamespaceDetailOverView }) {
  const [visible, setVisible] = useState(false);

  const loadDetail = useMemoizedFn(async () => {
    fetctNamespaceDetailOverView({
      clusterName,
      namespace,
    });
  });

  useEffect(() => {
    if (visible) {
      loadDetail();
    }
  }, [loadDetail, visible]);

  const handleDelete = async () => {
    const { meta } = await deleteNamespace({
      clusterName,
      namespace,
    });
    // 主集群创建的资源已在灾备集群存在
    if (meta.code === 70101) {
      deal70101(meta.publicMessage, handleDelete, {
        url: '/cluster/namespace/list',
        namespace, // 完整路径
      });
      return;
    }
    MessagePlugin.success('删除成功！');
    setVisible(false);
    onDelete();
  };

  const onClose = () => setVisible(false);

  const commonProps = {
    clusterName,
    namespace,
  };

  return (
    <>
      <Link theme='primary' onClick={() => setVisible(true)}>
        {namespace}
      </Link>
      <Drawer
        size={1100}
        destroyOnClose
        header={
          <ModalHeader
            tags={[clusterName, namespace]}
            tail={
              <PermWrapper resource='pulsar:namespace:list:delete'>
                <Popconfirm theme='danger' content='确定删除？' onConfirm={handleDelete}>
                  <DisableWrapper>
                    <Button theme='danger' variant='outline' size='small' icon={<DeleteIcon />}>
                      删除
                    </Button>
                  </DisableWrapper>
                </Popconfirm>
              </PermWrapper>
            }
          >
            命名空间
          </ModalHeader>
        }
        visible={visible}
        onClose={onClose}
        footer={null}
      >
        <Loading loading={loading}>
          <Root>
            <Summary />
            <Tabs defaultValue={1}>
              <TabPanel value={1} label='概览' destroyOnHide>
                <BasicPanel commonProps={commonProps} onRefresh={loadDetail} />
              </TabPanel>
              <TabPanel value={2} label='权限' destroyOnHide>
                <PermissionPanel clusterName={clusterName} namespace={namespace} />
              </TabPanel>
              <TabPanel value={3} label='配置' destroyOnHide>
                <ConfigPanel clusterName={clusterName} namespace={namespace} />
              </TabPanel>
              <TabPanel value={4} label='GEO' destroyOnHide>
                <GeoPanel namespace={namespace} />
              </TabPanel>
            </Tabs>
          </Root>
        </Loading>
      </Drawer>
    </>
  );
}

export default connect(
  (state) => ({
    loading: state.namespace.loading,
  }),
  {
    fetctNamespaceDetailOverView,
  },
)(Detail);

const Root = styled.div`
  margin-top: -15px;
`;
